<template>
    <div @paste="paste" style="padding: 100px; text-align: center">

        <div v-if="!image">
            <h2>Copy&paste the image to this page</h2>
            <a href="https://miro.com/app/board/o9J_ld0yJdU=/"><h2>docs Miro board</h2></a>
        </div>

        <div v-if="image">
            <h2>Uploaded File</h2>
            <div class="img-wrapper">
                <img style="max-width:100%; max-height: 600px;" :src="image">
            </div>
        </div>

        <div v-if="file_url">
            <h2>URL</h2>
            <b>Paste this code into your markdown files</b><br>
            <textarea style="display: inline-block; width: 800px;" id="url-textarea">![image]({{ file_url }} "Image")</textarea>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'data'
    ],
    data() {
        return {
            'text': '',
            image: null,
            file_url: null
        };
    },
    methods: {
        paste(pasteEvent, callback) {
            this.image = null;
            this.file_url = null;
            var items = pasteEvent.clipboardData.items;

            for (var i = 0; i < items.length; i++) {
                if (items[i].type.indexOf("image") == -1) continue;
                var blob = items[i].getAsFile();
                this.addImage(blob)
            }
        },
        addImage(file){
            if (!file.type.match('image.*')) {
                return new Promise((reject) => {
                    reject()
                })
            }

            let reader = new FileReader();
            reader.onload = (e) => this.image = e.target.result;
            reader.readAsDataURL(file);

            this.uploadFile(file);
        },
        uploadFile(file) {
            let formData = new FormData();
            formData.append('files[0]', file);

            return axios.post( url(`ajax/admin/upload-file-public`), formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(response => {
                this.file_url = response.data.files[0].url;
                this.$nextTick(() => {
                    document.getElementById("url-textarea").select();
                });
            });
        }
    },
    mounted() {
    }
}
</script>

<style scoped>
 h2 {
     margin-top: 50px;
 }
</style>